import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Button,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { StyledTextField } from './StyledTextField'; // Ajuste o caminho

function UserInfoForm({ userInfo, onInputChange, onUpdateInfo, isCurrentUser }) {
  // ✅ NOVA FUNÇÃO PARA LIDAR ESPECIFICAMENTE COM A MUDANÇA DO TIPO
  const handleTipoChange = (event) => {
    // Converte a string 'Administrador'/'Usuário' de volta para um booleano
    const valorBooleano = event.target.value === 'Administrador';

    // Cria um objeto de evento simulado com o valor booleano correto
    const eventoParaState = {
      target: {
        name: 'tipo',
        value: valorBooleano,
      },
    };

    // Chama a função do componente pai com os dados corretos
    onInputChange(eventoParaState);
  };

  return (
    <Card sx={{ bgcolor: '#2C2C2F', color: '#fff', borderRadius: 3 }}>
      <CardHeader
        title="Redefinir Informações"
        sx={{ borderBottom: '1px solid #444' }}
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <StyledTextField
              fullWidth
              required
              label="Nome"
              name="nome"
              value={userInfo.nome}
              onChange={onInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <StyledTextField
              fullWidth
              required
              label="Email"
              name="email"
              type="email"
              value={userInfo.email}
              onChange={onInputChange}
              disabled={isCurrentUser}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel
                sx={{ color: '#9e9e9e', '&.Mui-focused': { color: '#fff' } }}
              >
                Tipo do Usuário
              </InputLabel>
              <Select
                label="Tipo do Usuário"
                name="tipo"
                // ✅ CORREÇÃO 1: Converte o booleano para string para exibir o valor
                value={userInfo.tipo === true ? 'Administrador' : 'Usuário'}
                // ✅ CORREÇÃO 2: Usa a nova função para salvar o valor como booleano
                onChange={handleTipoChange}
                disabled={isCurrentUser}
                sx={{
                  color: '#e0e0e0',
                  backgroundColor: '#3A3A3D',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#555',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#777',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#fff',
                  },
                  '& .MuiSvgIcon-root': { color: '#9e9e9e' },
                }}
              >
                {/* As opções continuam as mesmas */}
                <MenuItem value="Usuário">Usuário</MenuItem>
                <MenuItem value="Administrador">Administrador</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            color="primary"
            onClick={onUpdateInfo}
          >
            Alterar informações
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default UserInfoForm;
